import { Route, Routes } from 'react-router-dom'; 
import Navbar from './Navbar';
import Home from './Home';
import Class1 from './Class1';
import Class2 from './Class2';
import Class4 from './class4';
import Class3 from './class3';
import Events from './Events';
import Footer from './Footer';

export default function App() {
  return (
    <div className='bg-slate-200'>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path='/classes/1' element={<Class1 />} />
        <Route path='/classes/2' element={<Class2 />} />
        <Route path='/classes/3' element={<Class3 />} />
        <Route path='/classes/4' element={<Class4 />} />
        <Route path='/events' element={<Events />} />
      </Routes>
      <Footer />
    </div>
  );
}